import { render, staticRenderFns } from "./Descuentos.vue?vue&type=template&id=054d24f8&"
import script from "./Descuentos.vue?vue&type=script&lang=js&"
export * from "./Descuentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports